import { USER_NAMESPACE, PROJECT_NAMESPACE } from '../../utils/constants';
import { handleResponse } from './handleResponse';

const basicHeaders = {
    "Accept-encoding": "gzip, deflate"
};

function headersBuilder(token, subscriptionBucket) {
    let customHeaders = Object.assign({}, basicHeaders);
    customHeaders.Authorization = "Bearer " +token;
    if (subscriptionBucket) {
        customHeaders["Graphologi-Target"] = subscriptionBucket;
    }
    return new Headers(customHeaders);
}

async function getEntitlements(user, subscription, bucket) {

    const requestOptions = {
        method: 'GET',
        headers: headersBuilder(user.token, bucket),
        mode: 'cors',
        cache: 'no-cache'
    };

    const userID = user.id.substring(USER_NAMESPACE.length);

    return fetch(`${process.env.REACT_APP_API_URL}/user/${userID}/entitlement?subscription=${subscription}`, requestOptions)
        .then(handleResponse)
        .then(entitlements => {
            return entitlements;
        });
}

async function getProjectEntitlements(user, subscription, bucket, projectIRI) {

    const requestOptions = {
        method: 'GET',
        headers: headersBuilder(user.token, bucket),
        mode: 'cors',
        cache: 'no-cache'
    };

    const userID = user.id.substring(USER_NAMESPACE.length);
    const projectID = projectIRI.substring(PROJECT_NAMESPACE.length);

    return fetch(`${process.env.REACT_APP_API_URL}/user/${userID}/projectentitlement/${projectID}?subscription=${subscription}`, requestOptions)
        .then(handleResponse)
        .then(entitlements => {
            return entitlements;
        });
}

async function getGroups(user, subscription, bucket) {

    const requestOptions = {
        method: 'GET',
        headers: headersBuilder(user.token, bucket),
        mode: 'cors',
        cache: 'no-cache'
    };

    const userID = user.id.substring(USER_NAMESPACE.length);

    return fetch(`${process.env.REACT_APP_API_URL}/user/${userID}/group?subscription=${subscription}`, requestOptions)
        .then(handleResponse)
        .then(groups => {
            return groups;
        });
}

async function getManagedGroups(user, subscription, bucket) {

    const requestOptions = {
        method: 'GET',
        headers: headersBuilder(user.token, bucket),
        mode: 'cors',
        cache: 'no-cache'
    };

    const userID = user.id.substring(USER_NAMESPACE.length);

    return fetch(`${process.env.REACT_APP_API_URL}/user/${userID}/managedgroup?subscription=${subscription}`, requestOptions)
        .then(handleResponse)
        .then(groups => {
            return groups;
        });
}

export const authorisationService = {
    getEntitlements,
    getProjectEntitlements,
    getGroups,
    getManagedGroups
};
